<form
  nz-form
  [formGroup]="uploadForm"
  class="form"
  nzLayout="horizontal"
  (ngSubmit)="submitForm()">
  <div class="drawer-form-wrapper">
    <nz-form-item>
      <nz-form-label>Organization File</nz-form-label>
      <nz-form-control [nzErrorTip]="'Upload organization file'">
        <nz-upload
          [nzFileList]="organizationFile"
          [nzBeforeUpload]="beforeOrganizationUpload"
          [nzShowUploadList]="true"
          [nzRemove]="handleFileRemove('organization')"
          [nzIconRender]="iconTemplate"
          [nzMultiple]="false"
          [nzAccept]="'.csv'"
          nzDrop
          nzListType="picture"
          class="file-upload">
          <button nz-button type="button">
            <div class="upload-icon">
              <svg-icon
                [title]="'Upload organization file'"
                src="/assets/icon/icon-upload.svg"
                class="icon s-12"
                aria-label="Upload"></svg-icon>
            </div>
            <div class="wrapper">
              <p class="text s-14 fw-600 green">
                Click to upload
                <span class="text s-14 fw-400">or drag and drop</span>
              </p>
              <p class="text s-12 fw-400">CSV files only</p>
            </div>
          </button>
          <app-upload-progress
            [progress$]="uploadProgress$"></app-upload-progress>
        </nz-upload>
      </nz-form-control>
    </nz-form-item>

    <div class="btn-wrapper-end">
      <a
        href="/assets/samplefiles/SampleOneRosterOrgFile.csv"
        download="SampleOneRosterOrgFile.csv"
        nz-button
        nzType="text"
        class="primary-text-btn">
        Sample Import File
      </a>
    </div>

    <nz-form-item>
      <nz-form-label>User File</nz-form-label>
      <nz-form-control [nzErrorTip]="'Upload user file'">
        <nz-upload
          [nzFileList]="userFile"
          [nzBeforeUpload]="beforeUserUpload"
          [nzShowUploadList]="true"
          [nzRemove]="handleFileRemove('user')"
          [nzIconRender]="iconTemplate"
          [nzMultiple]="false"
          [nzAccept]="'.csv'"
          nzDrop
          nzListType="picture"
          class="file-upload">
          <button nz-button type="button">
            <div class="upload-icon">
              <svg-icon
                [title]="'Upload user file'"
                src="/assets/icon/icon-upload.svg"
                class="icon s-12"
                aria-label="Upload"></svg-icon>
            </div>
            <div class="wrapper">
              <p class="text s-14 fw-600 green">
                Click to upload
                <span class="text s-14 fw-400">or drag and drop</span>
              </p>
              <p class="text s-12 fw-400">CSV files only</p>
            </div>
          </button>
        </nz-upload>
      </nz-form-control>
    </nz-form-item>

    <div class="btn-wrapper-end">
      <a
        href="/assets/samplefiles/SampleOneRosterUsersFile.csv"
        download="SampleOneRosterUsersFile.csv"
        nz-button
        nzType="text"
        class="primary-text-btn">
        Sample Import File
      </a>
    </div>

    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button nzType="default" (click)="closeImportDrawer()">
        Cancel
      </button>
      <button
        type="submit"
        nz-button
        [nzLoading]="loading$ | async"
        [disabled]="userFile.length === 0 || organizationFile.length === 0"
        nzType="primary">
        Import File
      </button>
    </div>
  </div>
</form>
<ng-template #iconTemplate let-file>
  <svg-icon
    src="/assets/icon/icon-csv.svg"
    class="icon s-12"
    aria-label="Csv"></svg-icon>
</ng-template>
